import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import { HeaderAlertText } from "./header-alert-text.tsx";

const AlertPopupHeader = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1000}
      height={40}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <HeaderAlertText />
    </ET3Div>
  );
});

export default AlertPopupHeader;
